/** This export is automatically generated */
export const gitHash = '4d8ab8245';
